var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0634 28C22.1389 28 28.7437 17.9962 28.7437 9.32103C28.7437 9.03689 28.7437 8.75403 28.7245 8.47245C30.0094 7.54313 31.1185 6.39245 32 5.0743C30.8018 5.60521 29.5307 5.95338 28.2291 6.10718C29.5997 5.28674 30.6254 3.99632 31.1155 2.47609C29.8268 3.24077 28.4168 3.77969 26.9466 4.06957C24.9115 1.90575 21.6777 1.37615 19.0586 2.77773C16.4395 4.17932 15.0864 7.16352 15.7581 10.057C10.4792 9.79236 5.56093 7.29919 2.2272 3.19795C0.484637 6.1976 1.3747 10.035 4.25984 11.9615C3.21503 11.9305 2.193 11.6487 1.28 11.1398C1.28 11.1667 1.28 11.1948 1.28 11.223C1.28086 14.348 3.48384 17.0396 6.5472 17.6583C5.58063 17.9219 4.5665 17.9605 3.58272 17.771C4.44281 20.4452 6.90762 22.2773 9.71648 22.33C7.39166 24.157 4.51976 25.1488 1.56288 25.1458C1.04052 25.1448 0.518661 25.1132 0 25.0511C3.00241 26.9777 6.49589 27.9996 10.0634 27.9949",
    fill: "var(--template-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.3ede6ce4f8c9f15302fe2c033700add4.svg";
export { ForwardRef as ReactComponent };